// Brand assets — the real Dhara Kala Movies logo and hero banner
export const BRAND_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_dhara-kala-films/artifacts/s5d2oyc8_ChatGPT_Image_Aug_10__2026__08_53_02_PM-removebg-preview.png";
export const BRAND_BANNER = "https://customer-assets-agu9un31.emergentagent.net/job_dhara-kala-films/artifacts/fsy0hxgs_DharaKala.png";
